import { render, staticRenderFns } from "./CRules.vue?vue&type=template&id=8c6edf0a"
import script from "./CRules.vue?vue&type=script&lang=js"
export * from "./CRules.vue?vue&type=script&lang=js"
import style0 from "./CRules.vue?vue&type=style&index=0&id=8c6edf0a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports